import React from 'react';

export default function PictoAmerican40() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_840_576)">
        <path
          d="M36.8501 16C18.6402 16.4568 15.0899 25.5923 20.0146 34.6136C20.9081 36.2504 24.4811 35.9839 24.4811 35.9839C27.917 35.9839 30.7802 34.842 33.0707 32.4439C38.339 27.191 37.9954 17.5987 37.9954 17.1419C37.9954 16.4568 37.5373 16 36.8501 16Z"
          fill="#DAD8D2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.356 31.7444L32.3476 31.7532C30.2615 33.9372 27.6676 34.9839 24.4811 34.9839H24.4439L24.408 34.9866L24.4068 34.9867L24.4041 34.9869L24.3821 34.9882C24.3612 34.9895 24.3283 34.9912 24.2848 34.993C24.1976 34.9966 24.069 35.0003 23.9106 35C23.5912 34.9994 23.1639 34.983 22.7189 34.9219C22.2676 34.8599 21.8389 34.7574 21.4963 34.6048C21.1504 34.4507 20.9731 34.2825 20.8923 34.1344C18.5325 29.8116 18.3321 25.7234 20.5628 22.6872C22.8337 19.596 27.873 17.2281 36.8595 17.0001C36.9146 17.001 36.9467 17.0103 36.9609 17.0158C36.9685 17.0187 36.9726 17.021 36.9743 17.0222C36.9754 17.0238 36.9775 17.0275 36.9801 17.0344C36.9856 17.0485 36.9954 17.0823 36.9954 17.1419C36.9954 17.1592 36.9959 17.1878 36.9965 17.2273C37.0042 17.734 37.0389 20.0219 36.5252 22.8134C35.9673 25.8452 34.7877 29.3198 32.3647 31.7358L32.356 31.7444ZM36.8501 16C18.6402 16.4568 15.0899 25.5923 20.0146 34.6136C20.9081 36.2504 24.4811 35.9839 24.4811 35.9839C27.917 35.9839 30.7802 34.842 33.0707 32.4439C38.154 27.3755 38.0126 18.2672 37.9964 17.2233C37.9958 17.1853 37.9954 17.158 37.9954 17.1419C37.9954 16.4568 37.5373 16 36.8501 16Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 3H11C10.4477 3 10 3.44772 10 4V7H10.3379H18.2919H19V4C19 3.44772 18.5523 3 18 3ZM20 7.38296V4C20 2.89543 19.1046 2 18 2H11C9.89543 2 9 2.89543 9 4V7.23015C7.88084 7.62759 6.97036 8.51325 6.56249 9.6786L4.2183 16.3763C4.08168 16.5473 4 16.7641 4 17V34C4 36.2091 5.79086 38 8 38H21C22.487 38 23.7845 37.1886 24.4738 35.9844C24.4081 35.9889 23.9064 36.0202 23.2548 35.979C22.7049 36.6049 21.8986 37 21 37H8C6.34315 37 5 35.6569 5 34V17H24V18.6429C24.3196 18.4799 24.6528 18.3233 25 18.1734V17C25 16.7326 24.8951 16.4898 24.7241 16.3103L22.0058 9.51444C21.6225 8.55615 20.8954 7.80604 20 7.38296ZM18.2919 8H10.3379C9.06309 8 7.92749 8.80569 7.50635 10.0089L5.40948 16H23.523L21.0773 9.88583C20.6217 8.74685 19.5186 8 18.2919 8Z"
          fill="#142138"
        />
        <path
          d="M21 34C21 29.5 26 26 26 26"
          stroke="#142138"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_840_576">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
